import React from "react";
import {useParams} from "react-router";
import {css, Theme} from "@emotion/react";

import {PanelExpandable} from "@pg-design/expandable-module";
import {WideContent} from "@pg-design/grid-module";
import {listUnStyled, mb, mt, onDesktop, p, w100} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {IRankingAnnualParams, IRankingParams, rpAppLink} from "@pg-mono/rp-routes";

import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {generalRankingKeysType} from "../constants/ranking";
import {getRankingCitiesIdByYear} from "../utils/get_ranking_cities_ids";

export const AnnualRankingLinks = () => {
    const params = useParams<IRankingParams & Partial<Pick<IRankingAnnualParams, "year">>>();
    const {year} = params;
    const citiesIds = getRankingCitiesIdByYear(year as generalRankingKeysType);
    const {data: cities} = useGetRegionDetailListQuery({regionIds: citiesIds});

    if (!cities) {
        return null;
    }

    return (
        <WideContent css={[mt(5), mb(2), onDesktop(mt(8), mb(6))]}>
            <PanelExpandable
                css={panel}
                alwaysOpen
                title={
                    <Text as="p" variant="headline_6">
                        Wyniki roczne dla miast
                    </Text>
                }
            >
                <ul css={citiesLinkList}>
                    {cities.map((element) => {
                        if (element.slug === params.citySlug) {
                            return null;
                        }
                        return (
                            <li key={element.id}>
                                <Link href={getRankingYearUrl(element.slug, year)}>{element.name}</Link>
                            </li>
                        );
                    })}
                </ul>
            </PanelExpandable>
        </WideContent>
    );
};

const panel = (theme: Theme) => css`
    background-color: #fff;
    ${p(1, 2)};

    @media (min-width: ${theme.breakpoints.md}) {
        background-color: initial;
        padding: initial;
    }
`;

const citiesLinkList = (theme: Theme) => css`
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 2.4rem;
    ${w100};
    ${listUnStyled};

    @media (min-width: ${theme.breakpoints.md}) {
        max-height: 8rem;
        flex-wrap: wrap;
        row-gap: 0.8rem;
    }
`;

function getRankingYearUrl(citySlug: string, year?: string) {
    if (year) {
        return rpAppLink.ranking.annualList({citySlug: citySlug, year: year});
    }

    return rpAppLink.ranking.lastYearList({citySlug: citySlug});
}
import React from "react";
import {useParams} from "react-router";
import {css, Theme} from "@emotion/react";

import {PanelExpandable} from "@pg-design/expandable-module";
import {WideContent} from "@pg-design/grid-module";
import {listUnStyled, mb, mt, onDesktop, p, w100} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {IRankingAnnualParams, IRankingParams, rpAppLink} from "@pg-mono/rp-routes";

import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {generalRankingKeysType} from "../constants/ranking";
import {getRankingCitiesIdByYear} from "../utils/get_ranking_cities_ids";

export const AnnualRankingLinks = () => {
    const params = useParams<IRankingParams & Partial<Pick<IRankingAnnualParams, "year">>>();
    const {year} = params;
    const citiesIds = getRankingCitiesIdByYear(year as generalRankingKeysType);
    const {data: cities} = useGetRegionDetailListQuery({regionIds: citiesIds});

    if (!cities) {
        return null;
    }

    return (
        <WideContent css={[mt(5), mb(2), onDesktop(mt(8), mb(6))]}>
            <PanelExpandable
                css={panel}
                alwaysOpen
                title={
                    <Text as="p" variant="headline_6">
                        Wyniki roczne dla miast
                    </Text>
                }
            >
                <ul css={citiesLinkList}>
                    {cities.map((element) => {
                        if (element.slug === params.citySlug) {
                            return null;
                        }
                        return (
                            <li key={element.id}>
                                <Link href={getRankingYearUrl(element.slug, year)}>{element.name}</Link>
                            </li>
                        );
                    })}
                </ul>
            </PanelExpandable>
        </WideContent>
    );
};

const panel = (theme: Theme) => css`
    background-color: #fff;
    ${p(1, 2)};

    @media (min-width: ${theme.breakpoints.md}) {
        background-color: initial;
        padding: initial;
    }
`;

const citiesLinkList = (theme: Theme) => css`
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 2.4rem;
    ${w100};
    ${listUnStyled};

    @media (min-width: ${theme.breakpoints.md}) {
        max-height: 8rem;
        flex-wrap: wrap;
        row-gap: 0.8rem;
    }
`;

function getRankingYearUrl(citySlug: string, year?: string) {
    if (year) {
        return rpAppLink.ranking.annualList({citySlug: citySlug, year: year});
    }

    return rpAppLink.ranking.lastYearList({citySlug: citySlug});
}
